import { createContext, useCallback, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { showErrorAlert } from "../alert/ErrorAlert";

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  let [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );
  let [user, setUser] = useState(() =>
    localStorage.getItem("authTokens")
      ? jwt_decode(localStorage.getItem("authTokens"))
      : null
  );
  let [loading, setLoading] = useState(true);

  let [isSzerkeszto] = useState(
    user && true ? user.role === "Admin" || user.role === "Szerkesztő" : false
  );
  let [isAdmin] = useState(user && true ? user.role === "Admin" : false);
  const navigate = useNavigate();
  const isLoggedIn = !!authTokens;

  let loginUser = async (e, credentials) => {
    e.preventDefault();
    let response = await fetch(`/api/token/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(credentials)
    });
    let data = await response.json();
    if (response.status === 200) {
      setAuthTokens(data);
      setUser(jwt_decode(data.access));
      localStorage.setItem("authTokens", JSON.stringify(data));
      navigate("/");
    } else {
      showErrorAlert({
        title:
          "Sikertelen bejelentkezés! Helytelen felhasználónév vagy email cím!",
        text: "Kérlek a bejelentkezés felületén próbálj újra belépni"
      });
    }
  };

  const registerUser = async (e) => {
    e.preventDefault();

    const response = await fetch(`/api/register/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        username: e.target.username.value,
        password: e.target.password.value,
        email: e.target.email.value
      })
    });
    let data = await response.json();
    if (response.status === 200) {
      loginUser(e, {
        username: e.target.username.value,
        password: e.target.password.value
      });
    } else {
      if (
        data.error === "Username already exists." ||
        data.error === "Ez a felhasználónév már létezik, válassz másikat!"
      ) {
        showErrorAlert({
          title: "Ez a felhasználónév már foglalt! Válassz másikat!"
        });
      } else if (data.error === "Email already exists.") {
        showErrorAlert({
          title: "Ez az email cím már használatban van! Válassz másikat!"
        });
      } else {
        showErrorAlert({
          title: "Ismeretlen hiba történt!",
          text: `${data.error}\n Ha a problémát nem sikerül megoldani keresd az admint: mindenegyseg@gmail.com`
        });
      }
    }
  };

  let logoutUser = useCallback(() => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem("authTokens");
    navigate("/login");
  }, [navigate]);

  let updateToken = useCallback(async () => {
    let response = await fetch(`/api/token/refresh/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authTokens?.refresh}`
      },
      body: JSON.stringify({ refresh: authTokens?.refresh })
    });
    let data = await response.json();
    if (response.status === 200) {
      setAuthTokens(data);
      setUser(jwt_decode(data.access));
      localStorage.setItem("authTokens", JSON.stringify(data));
    } else if (response.status === 401) {
      if (data.code === "token_not_valid") {
        console.log("Blacklisted token");
      } else {
        showErrorAlert(
          "Az automatikus bejelentkezés nem sikerült, kérlek lépj be újra!"
        );
        logoutUser();
      }
    } else {
      console.log("Nem 200 response status!:", response.status);
    }
    if (loading) {
      setLoading(false);
    }
  }, [authTokens, loading, logoutUser]);

  let contextData = {
    user: user,
    authTokens: authTokens,
    loginUser: loginUser,
    logoutUser: logoutUser,
    registerUser: registerUser,
    updateToken: updateToken,
    isAdmin: isAdmin,
    isSzerkeszto: isSzerkeszto,
    isLoggedIn: isLoggedIn // Új konstans hozzáadása a contextData-hoz
  };

  useEffect(() => {
    if (loading) {
      if (authTokens) {
        updateToken();
      } else {
        setLoading(false);
      }
    }

    let fourMinutes = 1000 * 60 * 4;

    let interval = setInterval(() => {
      if (authTokens) {
        updateToken();
      }
    }, fourMinutes);
    return () => clearInterval(interval);
  }, [authTokens, loading, updateToken]);

  return (
    <AuthContext.Provider value={contextData}>
      {loading ? null : children}
    </AuthContext.Provider>
  );
};
